import axios from 'axios';
import Cookies from 'js-cookie';

import { crmLoginPathFromLocation, isCrmBrowserPath } from '@crm/crmPaths';

export const api = axios.create({
  baseURL: '/api',
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  config.headers['Cache-Control'] = 'no-store';
  config.headers.Pragma = 'no-cache';
  const url = config.url ?? '';
  // Иначе на странице CRM в заголовок попадёт crm_token, а requireAuth('owner') читает заголовок первым.
  if (url.includes('/auth/crm/bootstrap-from-owner')) {
    return config;
  }
  // Тип токена определяем прежде всего по API namespace, а не по открытой странице.
  // На CRM login одновременно выполняются /auth/owner/verify и /auth/crm/verify.
  const isOwnerRequest = /^\/?(?:auth\/owner|owner)(?:\/|$)/.test(url);
  const isCrmRequest = /^\/?(?:auth\/crm|crm)(?:\/|$)/.test(url);
  const token = isOwnerRequest
    ? Cookies.get('owner_token')
    : isCrmRequest
      ? Cookies.get('crm_token')
      : isCrmBrowserPath(window.location.pathname)
        ? Cookies.get('crm_token')
        : Cookies.get('owner_token');
  if (token) {
    config.headers['x-access-token'] = token;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const reqUrl = error.config?.url ?? '';
      // 401 от verify/login — штатный результат на форме авторизации. Его обрабатывают
      // auth-slice и сама форма; hard redirect здесь создавал бесконечную перезагрузку.
      if (/\/?auth\/(?:crm|owner)(?:\/|$)/.test(reqUrl)) {
        return Promise.reject(error);
      }
      const isCrm = isCrmBrowserPath(window.location.pathname);
      if (isCrm) {
        Cookies.remove('crm_token');
        const loginPath = crmLoginPathFromLocation();
        if (window.location.pathname !== loginPath) {
          window.location.assign(loginPath);
        }
      } else if (window.location.pathname.startsWith('/profile')) {
        Cookies.remove('owner_token');
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  },
);
